<template>
  <div class="p-4 sm:p-6 space-y-8">
    <EmailCampaignStatistics :email-campaign="emailCampaign" @switch-tab="handleSwitchTab" />
    <div v-if="emailCampaign.email_addresses_count" class="bg-gray-100 rounded-lg">
      <div class="flex justify-center">
        <OverviewChart :email-campaign="emailCampaign" />
      </div>
    </div>
  </div>
</template>

<script>
import EmailCampaignStatistics from './EmailCampaignStatistics.vue';
import OverviewChart from './OverviewChart.vue';

export default {
  components: {
    EmailCampaignStatistics,
    OverviewChart,
  },
  props: {
    emailCampaign: {
      type: Object,
      required: true,
    },
  },
  methods: {
    handleSwitchTab({ tab, options }) {
      this.$emit('switch-tab', { tab, options });
    },
  },
};
</script>
